<ngx-spinner [name]="'relatorio-mercadorias-vendidas'" type="ball-clip-rotate-pulse" [fullScreen]="false"
    bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Relatório de mercadorias vendidas</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>

        <div class="row mt-2">

            <div class="col-sm">
                <mat-form-field appearance="fill" style="width: 100%;">
                    <mat-label>Números dos pedidos</mat-label>
                    <mat-chip-list #chipList aria-label="Fruit selection">
                        <mat-chip *ngFor="let numero of numerosPedidos" [selectable]="selectable"
                            [removable]="removable" (removed)="remove(numero)">
                            {{numero}}
                            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                        </mat-chip>
                        <input type="number" [min]="1" placeholder="Números dos pedidos..." #pedidosInput
                            [formControl]="numerosCtrl" [matChipInputFor]="chipList"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)">
                    </mat-chip-list>
                </mat-form-field>
            </div>


            <div class="col-auto">
                <button class="mt-4" mat-flat-button color="primary" (click)="gerarRelatorio()">
                    <mat-icon>search</mat-icon> Buscar
                </button>
            </div>
        </div>

        <div class="row mt-4" *ngIf="bConsulta">
            <div class="col-sm">
                <mat-divider></mat-divider>

                <div class="row mt-2">
                    <div class="col-sm text-right">
                        <button mat-flat-button color="warn" (click)="exportar()">
                            <mat-icon>print</mat-icon> Exportar
                        </button>
                    </div>
                </div>

                <div class="row mt-4">

                    <div class="col-auto">
                        <div class="borda">
                            <div style="margin: 16px;">
                                <div class="preContador">Total de produtos: {{contTotalProdutosGeral}}</div>
                                <div *ngFor="let totalProdutos of totalIndividualProdutosComprados">
                                    <div style="display: inline-block; margin-top: 2px;">{{totalProdutos.Nome}}:</div>
                                    <div style="font-weight: bold; display: inline-block; margin-left: 3px;">
                                        {{totalProdutos.QuantidadeComprada}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-sm">
                        <div style="color: gray; font-size: small;">* Pedidos cancelado não são contabilizados</div>
                    </div>
                </div>
            </div>
        </div>

        <mat-divider *ngIf="bConsulta"></mat-divider>

        <div class="row mt-4" *ngIf="bConsulta">
            <div class="col-auto">
                <button mat-flat-button color="warn" (click)="limparCampos()">
                    <mat-icon>clear</mat-icon> Limpar Campos
                </button>
            </div>
        </div>
    </mat-card-content>
</mat-card>